import { Link } from 'react-router-dom'
import type { DeliveryType } from '../../utils/deliveryHelper'
import type { MealT } from '../../models/menus'
import { getFormattedPriceByDeliveryType } from '../../utils/formattedPrice'
import Arrow from '../../icons/Arrow'
import styles from './MealItem.module.css'

type PropsT = {
  meal: MealT;
  href: string;
  deliveryType: DeliveryType;
}

function MealItem ({ href, meal, deliveryType }: PropsT) {
  const { name, description, image } = meal

  return (
    <li className={styles.item}>
      <Link className={styles.itemContent} to={href}>
        <>
          <div className={styles.content}>
            <div className={styles.leftContent}>
              {!!image && (
                <>
                  <div className={styles.imageContainer}>
                    <img
                      className={styles.image}
                      src={image}
                      alt={`Produktbild ${name}`}
                    />
                  </div>
                </>
              )}
            </div>
            <div className={styles.headingContent}>
              <h3 className={styles.heading}>{name}</h3>
              <span className={styles.price}>{getFormattedPriceByDeliveryType(meal, deliveryType)}</span>
            </div>
          </div>
          <div className={styles.rightContent}>
            <p className={styles.description}>{description}</p>
          </div>
          <div className={styles.customize}>
            <p>Anpassa vara</p>
            <Arrow className={styles.icon} direction="right" color="#cf2e05" />
          </div>
        </>
      </Link>
    </li>
  )
}
export default MealItem
